<app-page-header></app-page-header>
<main class="main-content">
  <router-outlet />
  @if(showCopyright()){
  <app-copyright />
  }
</main>
<app-page-footer></app-page-footer>